// extracted by mini-css-extract-plugin
export var errorsContainer = "_t3-1";
export var link = "_t3-0";